<template>
  <div v-loading="productDetailIng" class="edit-product">
    <el-form
      ref="editProductForm"
      class="prudoct-form"
      :model="editProductForm"
      label-width="160px"
      :rules="editProductFormRules"
    >
      <div class="box">
        <div class="title">基本信息</div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品名称：" class="skuName" prop="skuName">
              <el-input v-model="editProductForm.skuName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="品牌：">
              <el-select
                v-model="editProductForm.brandId"
                placeholder="请选择品牌"
                @change="brandNameChange"
              >
                <el-option
                  v-for="bitem in brandList"
                  :key="bitem.brandId"
                  :label="bitem.brandName"
                  :value="bitem.brandId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税率(%)：" prop="taxRateId">
              <el-select
                v-model="editProductForm.taxRateId"
                placeholder="请选择税率"
                @change="taxRateChange"
              >
                <el-option
                  v-for="taxitem in taxList"
                  :key="taxitem.taxRateId"
                  :label="taxitem.taxRate"
                  :value="taxitem.taxRateId"
                >
                  <span>{{ taxitem.taxRate }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属分类：">
              <span>{{ editProductForm.categoryName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="销售范围：" class="p-relative">
              <el-select
                v-model="editProductForm.salesScope"
                placeholder="请选择销售范围"
                prop="salesScope"
                @change="salesScopeChange"
              >
                <el-option
                  v-for="item in salesScopeType"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="计量单位：" prop="unitId">
              <el-select
                v-model="editProductForm.unitValue"
                placeholder="请选择计量单位"
                prop="unitValue"
                @change="unitChange"
              >
                <el-option
                  v-for="item in unitList"
                  :key="item.unitName"
                  :label="item.unitName"
                  :value="item.unitName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="市场公开价(元)：" prop="price">
              <el-input
                v-model="editProductForm.price"
                placeholder="请输入市场公开价"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="库存：" prop="skuStock">
              <el-input
                v-model="editProductForm.skuStock"
                placeholder="请输入库存"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="起订量：" prop="minOrderQuantity">
              <el-input
                v-model="editProductForm.minOrderQuantity"
                placeholder="请输入起订量"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单是否确认：" prop="isConfirm">
              <el-select
                v-model="editProductForm.isConfirm"
                placeholder="请选择订单是否确认"
              >
                <el-option
                  v-for="item in isConfirmArr"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="交货期：" prop="deliveryType">
              <el-select
                v-model="editProductForm.deliveryType"
                placeholder="请选择交货期"
              >
                <el-option
                  v-for="item in deliveryTypeArr"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="发货周期(天)：" prop="deliverTime">
              <el-input
                v-model="editProductForm.deliverTime"
                placeholder="请输入发货周期"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品编号：">
              <span>{{ editProductForm.skuCode }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <div class="sub-title">属性</div>
          <el-row>
            <el-col
              v-for="(item, index) of editProductForm.specificationArr"
              :key="index"
              :span="12"
            >
              <el-form-item
                :label="item.attributeName + '：'"
                :prop="`specificationArr[${index}].attributeValue`"
                :rules="[
                  { required: true, message: '请选择规格', trigger: 'blur' },
                ]"
                class="attribute-value"
              >
                <el-input
                  v-model="item.attributeValue"
                  @focus="resetAttrValue(item, index)"
                ></el-input>
                <span>{{ item.unitValue }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="sub-title">规格</div>
          <el-row>
            <el-col
              v-for="(item, index) of editProductForm.attrArr"
              :key="index"
              :span="12"
            >
              <el-form-item
                :label="item.attributeName + '：'"
                :prop="`attrArr[${index}].attributeValue`"
                :rules="[
                  { required: true, message: '请选择规格', trigger: 'blur' },
                ]"
                class="attribute-value"
              >
                <el-input
                  v-model="item.attributeValue"
                  @focus="resetSpecValue(item, index)"
                ></el-input>
                <span>{{ item.unitValue }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="box">
        <div class="title">销售规则</div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="可售区域设置："
              class="p-relative"
              prop="salesScopeId"
            >
              <el-select
                v-model="editProductForm.salesScopeId"
                placeholder="请选择可售区域设置"
              >
                <el-option
                  v-for="item in areaArr"
                  :key="item.salesScopeId"
                  :label="item.salesScopeName"
                  :value="item.salesScopeId"
                ></el-option>
              </el-select>
              <el-tooltip
                class="icon"
                effect="dark"
                content="Right Center 提示文字"
                placement="right"
              >
                <div slot="content">
                  <p>销售范围：是指您的商品对全平台客户的销售范围；</p>
                  <p>全平台：表示对平台所有客户销售；</p>
                  <p>仅协议客户：表示对您设置的平台协议客户，以协议价销售；</p>
                </div>
                <div class="icon">?</div>
              </el-tooltip>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="备注：">
              <el-input
                v-model="editProductForm.remark"
                style="border-radius: unset"
                type="textarea"
                maxlength="200"
                :autosize="{ minRows: 3, maxRows: 8 }"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12"></el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="附件：">
              <file-upload
                :upload-url="uploadUrl"
                :url="pdfFileList"
                accept=".pdf"
                :limit="10"
                :is-p-d-f="true"
                :file-size="20"
                @getFileInfo="getFileInfo"
              >
                <template #message
                  >最多上传 10个文件，仅限 PDF 格式，文小不能超过 20M</template
                >
              </file-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="box">
        <h2 class="title">商品图片</h2>
        <div class="sub-title">
          <span>商品图片</span>
          至少上传一张，最多5张图片，支持JPG、JPEG、PNG格式，正方形图片，建议使用800*800px，单张大小不超过4M。
        </div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品图片：" required>
              <ul
                v-if="editProductForm.imageUrlsExist.length"
                class="el-upload-list el-upload-list--picture-card new-img-list"
              >
                <li
                  v-for="(item, index) in editProductForm.imageUrlsExist"
                  :key="index"
                  class="el-upload-list__item"
                >
                  <div class="img-shade">
                    <i class="el-icon-delete" @click="delProductImg(index)"></i>
                  </div>
                  <img :src="item" alt class="el-upload-list__item-thumbnail" />
                </li>
              </ul>
              <multi-image-upload
                v-if="editProductForm.imageUrlsExist.length < 5"
                :url="imageUrls"
                :has-del="true"
                :limit="imageUrlsLength"
                :image-size="4"
                :verify="true"
                :upload-tips.sync="imageUploadTips"
                @handleimgInfo="handleProducts"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="sub-title">
          <span>商品详情图片</span>
          至少上传一张，最多10张图片，支持JPG、JPEG、PNG格式，正方形图片，建议使用800*800px，单张大小不超过4M。
        </div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="商品详情图片：" required>
              <ul
                v-if="editProductForm.detailImageUrlsExist.length"
                class="el-upload-list el-upload-list--picture-card new-img-list"
              >
                <li
                  v-for="(item, index) in editProductForm.detailImageUrlsExist"
                  :key="index"
                  class="el-upload-list__item"
                >
                  <div class="img-shade">
                    <i class="el-icon-delete" @click="delDetailImg(index)"></i>
                  </div>
                  <img :src="item" alt class="el-upload-list__item-thumbnail" />
                </li>
              </ul>
              <multi-image-upload
                v-if="editProductForm.detailImageUrlsExist.length < 10"
                :url="detailImageUrls"
                :has-del="true"
                :limit="detailImageUrlsLength"
                :image-size="4"
                :verify="true"
                :upload-tips.sync="detailImageUploadTips"
                @handleimgInfo="handleProductsDetail"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-form-item class="submit-button">
        <el-button type="primary" @click="submitEditInfo">提交审核</el-button>
        <el-button @click="goBack">取消</el-button>
      </el-form-item>
    </el-form>

    <!-- 修改属性弹窗 -->
    <el-dialog
      key="1"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      title="取值选择"
      class="value-form"
      :visible.sync="attributeVisible"
      width="880px"
    >
      <el-form ref="attributeForm" :model="attributeForm" label-width="100px">
        <el-form-item label="属性名称" class="attribute-title">
          <span>{{ attributeForm.name }}</span>
        </el-form-item>
        <el-form-item
          class="value-item-form"
          prop="value"
          label="取值sssss"
          :rules="[
            { required: true, message: '请选择取值', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="attributeForm.value">
            <el-radio
              v-for="item in attributeValueList"
              :key="item.attributeValueId"
              :label="item.attributeValue"
            >
              {{ item.attributeValue }}
              <i
                v-if="String(item.attributeValueCode).includes('close')"
                class="el-icon-close"
                @click="deleteFormatVal(item.attributeValue)"
              ></i>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="attribute-add" label>
          <div class="attribute-add-item">
            <el-input v-model="attrVal" style="width: 120px"></el-input>
            <el-button @click="addAttrVal()">+</el-button>
          </div>
        </el-form-item>
        <span v-if="unitListAtt.length">
          <el-form-item
            prop="code"
            label="计量单位"
            :rules="[
              { required: true, message: '请选择计量单位', trigger: 'change' },
            ]"
          >
            <el-radio-group v-model="attributeForm.code">
              <el-radio
                v-for="item in unitListAtt"
                :key="item.unitId"
                :label="item.unitName"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
        </span>
        <span v-else>
          <el-form-item label="计量单位"></el-form-item>
        </span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancalAttrForm">取 消</el-button>
        <el-button type="primary" @click="sendAttrForm()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改规格弹窗 -->
    <el-dialog
      key="2"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      title="取值选择"
      class="value-form"
      :visible.sync="attributeValueVisible"
      width="880px"
    >
      <el-form
        ref="specificationForm"
        :model="specificationForm"
        label-width="100px"
      >
        <el-form-item label="规格名称" class="attribute-title">
          <span>{{ specificationForm.name }}</span>
        </el-form-item>
        <el-form-item
          class="value-item-form"
          prop="value"
          label="取值"
          :rules="[
            { required: true, message: '请选择取值', trigger: 'change' },
          ]"
        >
          <el-radio-group v-model="specificationForm.value">
            <el-radio
              v-for="item in attributeValueList"
              :key="item.attributeValueId"
              :label="item.attributeValue"
            >
              {{ item.attributeValue }}
              <i
                v-if="String(item.attributeValueCode).includes('close')"
                class="el-icon-close"
                @click="deleteFormatVal(item.attributeValue)"
              ></i>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="attribute-add" label>
          <div class="attribute-add-item">
            <el-input
              v-model="specVal"
              style="width: 120px"
              maxlength="20"
            ></el-input>
            <el-button @click="addSpecVal()">+</el-button>
          </div>
        </el-form-item>
        <span v-if="unitListAtt.length">
          <el-form-item
            prop="code"
            label="计量单位"
            :rules="[
              { required: true, message: '请选择计量单位', trigger: 'change' },
            ]"
          >
            <el-radio-group v-model="specificationForm.code">
              <el-radio
                v-for="item in unitListAtt"
                :key="item.unitId"
                :label="item.unitName"
              ></el-radio>
            </el-radio-group>
          </el-form-item>
        </span>
        <span v-else>
          <el-form-item label="计量单位"></el-form-item>
        </span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancalSpecForm">取 消</el-button>
        <el-button type="primary" @click="sendSpecForm()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import util from '../../../utils/utils';
import { epecToken } from '../../../utils/globalData';
import mixin from './mixin';
import api from '../../../api/product';
import FileUpload from './fileUpload.vue';

const numberReg3 = /^([0-9][0-9]*)+(\.[0-9]{1,3})?$/;
const numberReg2 = /^([0-9][0-9]*)+(\.[0-9]{1,2})?$/;
// const numberReg100 = /^([1-9]\d{0,1}|100)$/; // 1-100
// const numberReg365 = /^([1-9][0-9]?|[12][0-9][0-9]|3[0-5][0-9]|36[0-5])$/; // 1-365
const numberReg365 =
  /^([0-9]|[1-9][0-9]|[1-2][0-9][0-9]|[3][0-5][0-9]|(360|361|363|362|364|365))$/; // 0-365

function validatePrice(rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入市场公开价'));
  }
  if (!numberReg2.test(value) || value < 0 || value > 1000000000) {
    callback(new Error('请输入0-10亿之间的正数，小数点后最多2位'));
  } else {
    callback();
  }
}

function validateSkuStock(rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入库存'));
  }
  if (!numberReg3.test(value) || value <= 0 || value > 1000000) {
    callback(new Error('请输入0-100万的正数，小数点后最多3位'));
  } else {
    callback();
  }
}

function validateMinOrderQuantity(rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入起订量'));
  }
  if (!numberReg3.test(value) || value <= 0 || value > 1000000) {
    callback(new Error('请输入0-100万的正数，小数点后最多2位'));
  } else {
    callback();
  }
}

function validateDeliverTime(rule, value, callback) {
  console.log(value);
  if (!value) {
    return callback(new Error('请输入发货周期'));
  }
  console.log(value < 0, 'value >= 0 value >= 0 value >= 0 ');
  console.log(!numberReg365.test(value));
  if (!numberReg365.test(value)) {
    callback(new Error('请输入0-365的正数'));
  } else {
    callback();
  }
}
export default {
  components: {
    FileUpload,
  },
  mixins: [mixin],
  props: {
    productAuditId: {
      type: Number,
      default: 0,
    },
    skuId: {
      type: Number,
      default: 0,
    },
    ifEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skuNameV: '',
      remarkV: '',
      imageUrlsV: [],
      imageUrlsExistV: [],
      detailImageUrlsV: [],
      detailImageUrlsExistV: [],
      // 主图
      submitImageUrlsV: [],
      // 详情图
      submitDetailImageUrlsV: [],
      uploadUrl: api.fileUploadForProductFile,
      // 属性表单
      attributeForm: {
        value: '',
        code: '',
        name: '',
      },
      // 规格表单
      specificationForm: {
        value: '',
        code: '',
        name: '',
      },
      // 修改规格
      attributeValueVisible: false,
      // 修改属性
      attributeVisible: false,
      headers: epecToken,
      imageUploadTips: false,
      detailImageUploadTips: false,
      editProductForm: {
        // 商品名称
        skuName: '',
        // 品牌
        brandId: '',
        brandName: '',
        // 税率id
        taxRateId: '',
        taxRateValue: '',
        tax: '',
        // 计量单位
        unitId: '',
        unitValue: '',
        // 市场公开价
        price: '',
        // 库存
        skuStock: '',
        // 起订量
        minOrderQuantity: '',
        // 订单是否确认
        isConfirm: 1,
        // 发货周期
        deliverTime: '',
        // 可售区域设置
        salesScopeId: '',
        // 备注
        remark: '',
        // 附件列表
        skuFiles: [],
        // 主图
        imageUrls: [],
        imageUrlsTest: [],
        // 详情图
        detailImageUrls: [],
        detailImageUrlsTest: [],
        // 主图图库
        imageUrlsExist: [],
        // 详情图图库
        detailImageUrlsExist: [],
        salesScope: 0,
        deliveryType: null,
      },
      // 主图列表
      imageUrls: [],
      detailImageUrls: [],
      showImgViewer: false,
      // pdf回显列表
      pdfFileList: [],
      // 规格列表
      specificationList: [],
      attributeValueList: [],
      // 规格index
      specificationIndex: 0,
      // 属性index
      attributeIndex: 0,
      attributeValue: '',
      editProductFormRules: {
        skuName: [
          {
            required: true,
            message: '请输入商品名称',
            trigger: 'blur',
          },
        ],
        taxRateId: [
          {
            type: 'number',
            required: true,
            validator: '请选择税率',
            trigger: 'change',
          },
        ],
        unitName: [
          {
            type: 'string',
            required: true,
            message: '请选择计量单位',
            trigger: 'change',
          },
        ],
        price: [
          {
            required: true,
            validator: validatePrice,
            trigger: 'change',
          },
        ],
        skuStock: [
          {
            required: true,
            validator: validateSkuStock,
            trigger: 'blur',
          },
        ],
        minOrderQuantity: [
          {
            required: true,
            validator: validateMinOrderQuantity,
            trigger: 'blur',
          },
        ],
        isConfirm: [
          {
            required: true,
            message: '请选择订单是否确认',
            trigger: 'change',
          },
        ],
        deliverTime: [
          {
            required: true,
            validator: validateDeliverTime,
            trigger: 'blur',
          },
        ],
        salesScopeId: [
          {
            required: true,
            message: '请选择可售区域设置',
            trigger: 'change',
          },
        ],
      },
      // 主图
      submitImageUrls: [],
      // 详情图
      submitDetailImageUrls: [],
      // 接口数据
      resData: {},
      // 销售范围
      salesScopeType: [
        {
          value: '仅协议客户',
          key: 2,
        },
        {
          value: '全平台',
          key: 1,
        },
      ],
      salesScope: '',
      unitListAtt: [],
      specVal: '',
      attrVal: '',
      customName: '',
      flagSetNewAttr: false,
      flagSetNewSpec: false,
      // attributeStr: "",
      detailImageUrlsLength: 0,
      imageUrlsLength: 0,
      deliveryTypeArr: [
        {
          key: 1,
          value: '现货',
        },
        {
          key: 2,
          value: '期货',
        },
      ],
    };
  },
  created() {
    this.productAuditId && this.getAuditProductDetail(this.productAuditId);
  },

  methods: {
    goBack() {
      const { currentIndex } = this.$route.query;
      console.log(currentIndex);
      this.$router.push({
        path: '/goodsMaintenance',
        query: {
          currentIndex,
        },
      });
    },
    assembleName() {
      // 品牌（英文/中文名称）+空格+商品末级分类名称+空格+属性值1-N+规格值1-N（属性/规格值为该商品分类属性的前置符+取值+计量单位+后置符+连接符）
      // 这里组装数据
      const brandNameEN = this.editProductForm.brandNameEN
        ? `${this.editProductForm.brandNameEN}/`
        : '';
      console.log(brandNameEN, 'brandNameENbrandNameENbrandNameENbrandNameEN');
      const brandName = this.editProductForm.brandName || '';
      const categoryName = this.editProductForm.categoryName || '';
      // 属性修改
      let finalAttributeValue = '';
      // 规格修改
      let finalSpecificationValue = '';

      // 取属性名字: 雕牌 洗衣粉 去污粉盒\ 1360千克g  去渍清雅无磷千克  泡漂乐克
      this.editProductForm.specificationArr.forEach((item) => {
        this.attributeList.forEach((itemz) => {
          /* console.log(
            item,
            itemz.beforeSymbol,
            item.attributeValue,
            item.unitValue,
            itemz.behindSymbol,
            itemz.connectSymbol,
            "属性修改"
          ); */
          if (item.attributeName === itemz.attributeName) {
            finalAttributeValue +=
              itemz.beforeSymbol +
              item.attributeValue +
              item.unitValue +
              itemz.behindSymbol +
              itemz.connectSymbol;
          }
        });
      });

      // 取规格名字: beforeSymbol + temStr + behindSymbol + connectSymbol;
      this.editProductForm.attrArr.forEach((item) => {
        this.specificationList.forEach((itemz) => {
          if (item.attributeName === itemz.attributeName) {
            /* console.log(
              item,
              itemz.beforeSymbol,
              item.attributeValue,
              item.unitValue,
              itemz.behindSymbol,
              itemz.connectSymbol,
              "规格修改"
            ); */
            finalSpecificationValue +=
              itemz.beforeSymbol +
              item.attributeValue +
              item.unitValue +
              itemz.behindSymbol +
              itemz.connectSymbol;
          }
        });
      });

      console.log('属性:', finalAttributeValue);

      console.log('规格:', finalSpecificationValue);

      // 品牌（英文/中文名称）+空格+商品末级分类名称+空格+属性值1-N+规格值1-N（属性/规格值为该商品分类属性的前置符+取值+计量单位+后置符+连接符）
      const finalSkuName = `${brandNameEN}${brandName} ${categoryName} ${finalAttributeValue}${finalSpecificationValue}`;
      this.editProductForm.skuName = finalSkuName;

      // this.attributeStr = `${finalAttributeValue}`;
      this.editProductForm.specificationStr = `${finalAttributeValue}${finalSpecificationValue}`;
      this.editProductForm.attributeStr = `${finalAttributeValue}`;
    },

    // 删除商品图
    delProductImg(index) {
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.editProductForm.imageUrlsExist.splice(index, 1);
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        })
        .catch(() => {});
    },

    // 删除商品详情图
    delDetailImg(index) {
      this.$confirm('此操作将永久删除该图片, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.editProductForm.detailImageUrlsExist.splice(index, 1);
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
        })
        .catch(() => {});
    },

    // 删除自定义规格值
    deleteFormatVal(val) {
      const index = util.getArgumentIndexInAttr(
        this.attributeValueList,
        'attributeValue',
        val
      );
      this.attributeValueList.splice(index, 1);
    },

    // 增加自定义规格值
    addSpecVal() {
      if (util.deleteSpace(this.specVal) == '') {
        this.$message.warning('规格值不能为空！');
        return;
      }
      if (
        util.getArgumentIndexInAttr(
          this.attributeValueList,
          'attributeValue',
          this.specVal
        ) == -1
      ) {
        if (util.deleteSpace(this.specVal).length > 20) {
          this.$message.warning('规格值不能超过20个字符');
          return;
        }
        this.attributeValueList.push({
          attributeValue: this.specVal,
          attributeValueId: '',
          attributeValueCode: `${Math.random()}close`,
        });
        console.log(
          this.attributeValueList,
          'attributeValueListattributeValueList'
        );
      } else {
        this.$message.warning('规格值不能重复');
      }

      this.specVal = '';
    },

    // 增加自定义属性值
    addAttrVal() {
      if (util.deleteSpace(this.attrVal) == '') {
        this.$message.warning('规格值不能为空！');
        return;
      }
      if (
        util.getArgumentIndexInAttr(
          this.attributeValueList,
          'attributeValue',
          this.attrVal
        ) == -1
      ) {
        if (util.deleteSpace(this.attrVal).length > 20) {
          this.$message.warning('规格值不能超过20个字符');
          return;
        }
        this.attributeValueList.push({
          attributeValue: this.attrVal,
          attributeValueId: '',
          attributeValueCode: `${Math.random()}close`,
        });
        console.log(
          this.attributeValueList,
          'attributeValueListattributeValueList'
        );
      } else {
        this.$message.warning('规格值不能重复');
      }

      this.attrVal = '';
    },

    getFileInfo(fileList) {
      this.editProductForm.skuFiles = [...fileList];
      console.log(fileList, 'fileListfileListfileList');
    },

    // 修改品牌
    brandNameChange(brandId) {
      const brandObj = this.brandList.find((item) => item.brandId === brandId);
      Object.assign(this.editProductForm, brandObj);
      console.log(brandObj, 'brandObj');
      console.log(this.editProductForm, 'this.editProductForm');
      this.assembleName();
    },

    // 修改税率  问题就是 label 是一个字符串而不是number类型 接口给的是number类型
    taxRateChange(taxRateId) {
      const taxRateObj = this.taxList.find(
        (item) => item.taxRateId === taxRateId
      );
      Object.assign(this.editProductForm, taxRateObj);
      this.editProductForm.taxRateId = taxRateObj.taxRateId;
      this.editProductForm.taxRateValue = Number(taxRateObj.taxRate);
    },

    // 修改计量单位
    unitChange(unitName) {
      const unitObj =
        this.unitList.find((item) => item.unitName === unitName) || {};
      console.log(unitObj);
      delete unitObj.remark;
      Object.assign(this.editProductForm, unitObj);
      this.editProductForm.unitValue = unitObj.unitName;
    },

    async salesScopeChange(val) {
      console.log(val, typeof val);
      // 全品台 1 / 协议 2
      if (this.salesScope === 1) {
        return;
      }
      const params = {
        categoryId: this.editProductForm.categoryId,
      };
      const res = await api.queryCategoryByCompanyCategory(params);
      if (+res.code === 200) {
        if (!res.data) {
          this.$alert(
            '您好，所选商品存在不属于可售类目的商品，请先增加可售类目后再做销售范围变更。',
            '提示',
            {
              confirmButtonText: '确定',
              callback: () => {
                this.editProductForm.salesScope = 2;
              },
            }
          );
        }
      }
    },

    // 修改规格确定
    sendSpecForm() {
      this.$refs.specificationForm.validate((valid) => {
        if (valid) {
          console.log(
            this.specificationForm,
            'this.attributeFormthis.specificationForm'
          );
          console.log(
            this.editProductForm.attrArr,
            'this.editProductForm.attrArr'
          );

          const attributeValue = this.specificationForm.value;
          const attributeValueObj = this.attributeValueList.find((item) => {
            return item.attributeValue === attributeValue;
          });

          const unitValue = this.specificationForm.code;
          const unitValueObj =
            this.unitListAtt.find((item) => {
              return item.unitName === unitValue;
            }) || {};
          unitValueObj.unitValue = unitValue;

          // this.editProductForm.attrArr[this.specificationIndex] = {
          //   ...this.editProductForm.attrArr[this.specificationIndex],
          //   ...attributeValueObj,
          //   ...unitValueObj,
          // };

          const newObj = {
            ...attributeValueObj,
            ...unitValueObj,
            attributeId:
              this.editProductForm.attrArr[this.specificationIndex].attributeId,
            attributeName:
              this.editProductForm.attrArr[this.specificationIndex]
                .attributeName,
          };
          console.log(newObj);
          this.$set(
            this.editProductForm.attrArr,
            this.specificationIndex,
            newObj
          );
          console.log(
            this.editProductForm.attrArr,
            'this.editProductForm.attrArr'
          );
          this.attributeValueVisible = false;
          this.assembleName();
          // 确定完事一定要清除一一下表单
          this.$refs.specificationForm.resetFields();
        } else {
          return false;
        }
      });
    },

    // 修改属性确定
    sendAttrForm() {
      this.$refs.attributeForm.validate((valid) => {
        if (valid) {
          const attributeValue = this.attributeForm.value;
          const attributeValueObj = this.attributeValueList.find((item) => {
            return item.attributeValue === attributeValue;
          });

          const unitValue = this.attributeForm.code;
          console.log(unitValue, 'unitValue');
          const unitValueObj =
            this.unitListAtt.find((item) => {
              return item.unitName === unitValue;
            }) || {};
          unitValueObj.unitValue = unitValue;
          console.log(unitValueObj, 'unitValueObj属性');

          this.editProductForm.specificationArr[this.attributeIndex] = {
            ...this.editProductForm.specificationArr[this.attributeIndex],
            ...attributeValueObj,
            ...unitValueObj,
          };

          console.log(
            this.editProductForm.specificationArr,
            'this.editProductForm.specificationArr'
          );
          this.attributeVisible = false;
          this.assembleName();
          this.$refs.attributeForm.resetFields();
        } else {
          return false;
        }
      });
    },

    // 取消修改规格
    cancalSpecForm() {
      this.editProductForm.attrArr[this.specificationIndex].attributeValue =
        this.attributeValue;
      this.$refs.specificationForm.resetFields();
      this.attributeValueVisible = false;
    },

    // 取消修改属性
    cancalAttrForm() {
      this.editProductForm.specificationArr[
        this.attributeIndex
      ].attributeValue = this.attributeValue;
      this.$refs.attributeForm.resetFields();
      this.attributeVisible = false;
    },

    // 重新设置规格值
    resetSpecValue(item, index) {
      this.flagSetNewSpec = this.customName === item.attributeName;
      const { attributeValue = '', attributeName = '' } = item;
      this.customName = attributeName;
      this.specificationIndex = index;
      this.attributeValue = attributeValue;
      this.attributeValueVisible = true;
      console.log(this.attributeList, '属性');
      console.log(this.specificationList, '规格');

      if (!this.flagSetNewSpec) {
        const { attributeValueList = [] } =
          this.specificationList.find(
            (item) => item.attributeName === attributeName
          ) || {};
        const { unitList = [] } =
          this.specificationList.find(
            (item) => item.attributeName === attributeName
          ) || {};
        this.specificationForm.name = attributeName;
        this.attributeValueList = [...attributeValueList];
        this.unitListAtt = [...unitList];
      }
    },

    // 重新设置属性值
    resetAttrValue(item, index) {
      this.flagSetNewAttr = this.customName === item.attributeName;
      const { attributeValue = '', attributeName = '' } = item;
      this.customName = attributeName;
      this.attributeIndex = index;
      this.attributeValue = attributeValue;
      this.attributeVisible = true;
      console.log(this.attributeList, '属性');
      console.log(this.specificationList, '规格');

      if (!this.flagSetNewAttr) {
        const { attributeValueList = [] } =
          this.attributeList.find(
            (item) => item.attributeName === attributeName
          ) || {};
        const { unitList = [] } =
          this.attributeList.find(
            (item) => item.attributeName === attributeName
          ) || {};
        this.attributeForm.name = attributeName;
        this.attributeValueList = [...attributeValueList];
        this.unitListAtt = [...unitList];
      }
    },

    // 获取商品详情图片地址
    handleProductsDetail(imageInfo) {
      this.submitDetailImageUrls = [...imageInfo];
      this.editProductForm.detailImageUrlsTest = [...imageInfo];
    },

    // 获取商品图片地址
    handleProducts(imageInfo) {
      this.submitImageUrls = [...imageInfo];
      this.editProductForm.imageUrlsTest = [...imageInfo];
    },

    // 打开图片查看器
    openImgViewer(file) {
      // 获取要查看的图片临时地址
      this.imgPreviewList = [file.url];
      // 显示图片查看器
      this.showImgViewer = true;
    },

    // 关闭图片查看器
    closeImgViewer() {
      this.showImgViewer = false;
    },

    // 获取分类下的单位列表
    async getUnitData(categoryId) {
      const res = await api.getUnitByCategory({
        categoryId,
      });
      if (+res.code === 200) {
        this.unitList = [...res.data];
        // 处理自定义属性 unitId 没有 但是 unitValue有值的情况
        const unitObj = {};
        // unitObj.unitId = "";
        unitObj.unitName = this.editProductForm.unitValue;
        if (!this.editProductForm.unitId) {
          this.unitList.push(unitObj);
        }
      }
    },

    // -----

    async submitEditInfo() {
      console.log(this.editProductForm);
      const productName = util.deleteSpace(this.editProductForm.skuName);
      if (productName.length === 0) {
        this.$message.error('商品名称不能为空!');
        return;
      }

      const formValidated = await this.validateAndCheckImages();
      if (!formValidated) {
        return;
      }

      const updatedProductData = this.prepareProductFormData();

      if (this.productAuditId) {
        await this.handleProductUpdateWithAuditStatus(updatedProductData);
      } else {
        await this.handleRegularProductUpdate(updatedProductData);
      }
    },

    async validateAndCheckImages() {
      return new Promise((resolve) => {
        this.$refs.editProductForm.validate(async (valid) => {
          if (!valid) {
            resolve(false);
          } else if (
            this.editProductForm.imageUrlsExist.length === 0 &&
            this.submitImageUrls.length === 0
          ) {
            this.imageUploadTips = true;
            resolve(false);
          } else if (
            this.editProductForm.detailImageUrlsExist.length === 0 &&
            this.submitDetailImageUrls.length === 0
          ) {
            this.detailImageUploadTips = true;
            resolve(false);
          } else {
            resolve(true);
          }
        });
      });
    },

    prepareProductFormData() {
      this.editProductForm.imageUrls = this.submitImageUrls;
      this.editProductForm.detailImageUrls = this.submitDetailImageUrls;
      this.editProductForm.defaultImage =
        this.submitImageUrls.length !== 0
          ? this.submitImageUrls[0]
          : this.editProductForm.imageUrlsExist[0];

      const sku = {
        ...this.resData.productVO.skus[0],
        ...this.editProductForm,
      };
      sku.specificationStr = this.editProductForm.specificationStr;

      return {
        productAO: {
          ...this.resData.productVO,
          salesScope: this.editProductForm.salesScope,
          salesScopeId: this.editProductForm.salesScopeId,
          brandId: this.editProductForm.brandId,
          brandName: this.editProductForm.brandName,
          taxRateId: this.editProductForm.taxRateId,
          taxRateValue: this.editProductForm.taxRateValue,
          remark: this.editProductForm.remark,
          skuFiles: this.editProductForm.skuFiles || [],
          skus: [sku],
        },
        productAuditId: this.resData.productAuditId,
      };
    },

    async handleProductUpdateWithAuditStatus(productData) {
      const { auditStatus = '' } = this.$route.query;
      const { unsubmitProductRelease, productReleaseSubmitAgain } = api;
      let updateFn = unsubmitProductRelease;
      let successMessage = '提交成功，可在商品维护列表查看商品审核进度.';

      if (auditStatus === '104') {
        updateFn = productReleaseSubmitAgain;
        successMessage = '提交审核成功';
      }

      const res = await updateFn(productData);

      if (res.code === '200') {
        this.$message({
          message: successMessage,
          type: 'success',
        });

        this.removeCurrentTagAndGoBack();
      } else if (res.data?.errorCount === 1) {
        this.$message({
          type: 'warning',
          message: res.data.errorContent,
        });
      }
    },

    async handleRegularProductUpdate(productData) {
      const { productEditRelease } = api;
      const res = await productEditRelease(productData);

      if (res.code === '200') {
        this.$message({
          message: '编辑成功!',
          type: 'success',
        });

        this.removeCurrentTagAndGoBack();
      }
    },

    removeCurrentTagAndGoBack() {
      this.$store.state.tagsList = this.$store.state.tagsList.filter(
        (item) => item.fullPath !== this.$route.path
      );
      this.goBack();
    },

    // -------

    // 提交审核
    /* submitEditInfo() {
      const productName = util.deleteSpace(this.editProductForm.skuName);
      if (productName.length === 0) {
        this.$message.error('商品名称不能为空!');
        return;
      }
      this.$refs.editProductForm.validate(async (valid) => {
        if (this.editProductForm.imageUrlsExist.length === 0 && this.submitImageUrls.length === 0) {
          this.imageUploadTips = true;
          return false;
        }
        if (this.editProductForm.detailImageUrlsExist.length === 0 && this.submitDetailImageUrls.length === 0) {
          this.detailImageUploadTips = true;
          return false;
        }
        if (valid) {
          if (this.productAuditId) {
            this.editProductForm.imageUrls = this.submitImageUrls;
            this.editProductForm.detailImageUrls = this.submitDetailImageUrls;
            this.editProductForm.defaultImage =
              this.submitImageUrls.length !== 0 ? this.submitImageUrls[0] : this.editProductForm.imageUrlsExist[0];
            // this.editProductForm.defaultImage = this.editProductForm.imageUrls[0];
            Object.assign(this.resData.productVO.skus[0], this.editProductForm);
            const params = {};
            params.productAO = this.resData.productVO;
            params.productAO.salesScope = this.editProductForm.salesScope;
            params.productAO.salesScopeId = this.editProductForm.salesScopeId;
            params.productAuditId = this.resData.productAuditId;

            // 品牌和税率需要放在外层
            params.productAO.brandId = this.editProductForm.brandId;
            params.productAO.brandName = this.editProductForm.brandName;
            params.productAO.taxRateId = this.editProductForm.taxRateId;
            params.productAO.taxRateValue = this.editProductForm.taxRateValue;
            params.productAO.remark = this.editProductForm.remark;
            params.productAO.skuFiles = this.editProductForm.skuFiles || [];
            params.productAO.specificationStr = this.editProductForm.specificationStr; // this.attributeStr;
            this.resData.productVO.skus[0].specificationStr = this.editProductForm.specificationStr; // this.attributeStr;

            console.log(params, '提交数据');
            const { auditStatus = '' } = this.$route.query;
            const { unsubmitProductRelease, productReleaseSubmitAgain } = api;
            if (auditStatus === '104') {
              const res = await productReleaseSubmitAgain(params);
              if (res.code === '200') {
                this.$message({
                  message: '提交审核成功',
                  type: 'success',
                });
                this.$store.state.tagsList.map((item, index) => {
                  if (item.fullPath === this.$route.path) {
                    this.$store.state.tagsList.splice(index, 1);
                  }
                });
                this.goBack();
              }
            } else {
              const res = await unsubmitProductRelease(params);
              if (res.code === '200') {
                const { data } = res;
                if (data.errorCount === 1) {
                  this.$message({
                    type: 'warning',
                    message: data.errorContent,
                  });
                } else {
                  this.$message({
                    message: '提交成功，可在商品维护列表查看商品审核进度。',
                    type: 'success',
                  });
                }
                this.$store.state.tagsList.map((item, index) => {
                  if (item.fullPath === this.$route.path) {
                    this.$store.state.tagsList.splice(index, 1);
                  }
                });
                this.goBack();
              }
            }
          } else {
            // 这个是上下架的编辑提交
            this.editProductForm.imageUrls = this.submitImageUrls;
            this.editProductForm.detailImageUrls = this.submitDetailImageUrls;
            this.editProductForm.defaultImage =
              this.submitImageUrls.length !== 0 ? this.submitImageUrls[0] : this.editProductForm.imageUrlsExist[0];
            Object.assign(this.resData.skus[0], this.editProductForm);
            const params = {
              ...this.resData,
            };
            params.salesScope = this.editProductForm.salesScopeName;
            params.salesScopeId = this.editProductForm.salesScopeId;

            params.taxRateId = this.editProductForm.taxRateId;
            params.taxRateValue = this.editProductForm.taxRateValue;
            params.remark = this.editProductForm.remark;
            params.skuFiles = this.editProductForm.skuFiles;

            console.log(params, '提交数据');

            const { productEditRelease } = api;
            const res = await productEditRelease(params);
            if (res.code === '200') {
              this.$message({
                message: '编辑成功!',
                type: 'success',
              });
              this.$store.state.tagsList.map((item, index) => {
                if (item.fullPath === this.$route.path) {
                  this.$store.state.tagsList.splice(index, 1);
                }
              });
              this.goBack();
            }
          }

          // alert("submit!");
        }
      });
    }, */

    // 商品审核详情  外层是属性，内层是规格
    async getAuditProductDetail(productAuditId) {
      const { queryReleaseProductInfoById } = api;
      try {
        this.productDetailIng = true;
        const res = await queryReleaseProductInfoById({
          productAuditId,
        });
        this.productDetailIng = false;
        if (res.code === '200') {
          const data = res.data?.productVO?.skus[0];
          this.resData = res.data;
          data.skuCode = res.data.skuCode;
          const specificationArr = res.data?.productVO.attributes;
          const attrArr = data.attributes;
          data.attrArr = attrArr;
          data.specificationArr = specificationArr;
          if (data.imageUrls?.length) {
            this.imageUrls = [...data.imageUrls];
            this.submitImageUrls = [...data.imageUrls];
          }
          if (data.detailImageUrls?.length) {
            this.detailImageUrls = [...data.detailImageUrls];
            this.submitDetailImageUrls = [...data.detailImageUrls];
          }

          /* const imageUrls = data.imageUrls?.length ? data.imageUrls : [];
          const imageUrlsExist = data.imageUrlsExist?.length ? data.imageUrlsExist : [];
          this.imageUrls = [...imageUrls, ...imageUrlsExist]; */

          /* const detailImageUrls = data.detailImageUrls?.length ? data.detailImageUrls : [];
          const detailImageUrlsExist = data.detailImageUrlsExist?.length
            ? data.detailImageUrlsExist
            : [];
          this.detailImageUrls = [...detailImageUrls, ...detailImageUrlsExist]; */

          this.salesScope = data.salesScope;
          this.editProductForm = { ...this.editProductForm, ...data }; // 使用这个对象相应
          this.editProductForm.salesScope = data.salesScope
            ? data.salesScope
            : res.data.productVO.salesScope || null;
          this.editProductForm.taxRateId = data.taxRateId
            ? data.taxRateId
            : res.data.productVO.taxRateId;
          this.editProductForm.taxRateValue = data.taxRateValue
            ? data.taxRateValue
            : res.data.productVO.taxRateValue;
          this.editProductForm.salesScopeId = data.salesScopeId
            ? data.salesScopeId
            : res.data.productVO.salesScopeId
            ? res.data.productVO.salesScopeId
            : '';
          this.editProductForm.brandId = data.brandId
            ? data.brandId
            : res.data.productVO.brandId;
          this.editProductForm.brandName = data.brandName
            ? data.brandName
            : res.data.productVO.brandName;

          this.editProductForm.categoryId = data.categoryId
            ? data.categoryId
            : res.data.productVO.categoryId || null;
          this.editProductForm.categoryName = data.categoryName
            ? data.categoryName
            : res.data.productVO.categoryName || null;
          this.editProductForm.productId = data.productId
            ? data.productId
            : res.data.productVO.productId || null;
          this.pdfFileList = data.skuFiles
            ? data.skuFiles
            : res.data.productVO.skuFiles;
          this.editProductForm.skuFiles = data.skuFiles
            ? data.skuFiles
            : res.data.productVO.skuFiles;
          this.editProductForm.remark = data.remark
            ? data.remark
            : res.data.productVO.remark;

          console.log(this.editProductForm, 'this.editProductForm商品审核详情');
          this.imageUrlsLength = 5 - this.editProductForm.imageUrlsExist.length;
          this.detailImageUrlsLength =
            10 - this.editProductForm.detailImageUrlsExist.length;
          // 去掉表单回显验证
          this.$refs.editProductForm.resetFields();
          const { categoryId } = res.data.productVO;

          this.skuNameV = this.editProductForm.skuName;

          console.log(this.editProductForm.imageUrls);
          console.log(this.editProductForm.imageUrlsExist);
          console.log(this.editProductForm.detailImageUrls);
          console.log(this.editProductForm.detailImageUrlsExist);

          // 获取品牌名称
          this.getBrandList(categoryId);
          // 属性
          this.getAttributeData(categoryId);
          // 单位
          this.getUnitData(categoryId);
          // 规格
          this.getPropertyList(categoryId);
        } else {
          this.goBack();
        }
      } catch (error) {
        console.log(error);
      }
    },

    trim(str) {
      // 删除左右两端的空格
      return str.replace(/(^\s*)|(\s*$)/g, '');
    },
  },
};
</script>
<style lang="scss" scoped>
.edit-product {
  .box {
    padding: 20px 20px 0 20px;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin-top: 20px;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      padding-bottom: 20px;
    }

    ::v-deep .el-select .el-input .el-select__caret {
      color: #666;
    }
    .attribute-value {
      ::v-deep .el-input {
        width: calc(100% - 160px);
      }
      span {
        margin-left: 10px;
      }
    }
    /* ::v-deep .el-input__inner {
      border-color: #2587FF;
    } */
    ::v-deep .el-textarea__inner {
      border-radius: 0;
    }
    ::v-deep .warn-message {
      color: #999;
    }
  }
  .new-img-list {
    .el-upload-list__item {
      position: relative;
      &:hover {
        .img-shade {
          display: block;
        }
      }
      .img-shade {
        display: none;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        left: 0;
        top: 0;
        .el-icon-delete {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 20px;
        }
      }
    }
  }
  .value-form {
    ::v-deep .el-form {
      border: 1px solid #ededed;
      .attribute-title {
        background: #f5f5f5;
        color: #333333;
        border-bottom: 1px solid #ededed;
        .el-form-item__label {
          height: 40px;
          line-height: 40px;
          margin-top: 0 !important;
        }
        .el-form-item__content {
          padding: 0 0 0 10px !important;
          height: 40px;
          line-height: 40px;
        }
      }
      .el-form-item {
        margin-bottom: 0;
        border-bottom: 1px solid #ededed;
        .el-form-item__error {
          bottom: 2px;
          left: 10px;
          top: auto;
        }
        .el-form-item__label {
          margin-top: 8px;
          height: 40px;
          line-height: 40px;
        }
      }
      .el-form-item__content {
        border-left: 1px solid #ededed;
        padding-bottom: 20px;
        /* max-height: 260px;
        overflow: auto; */
        .el-radio-group {
          margin-left: 10px;
          padding-top: 20px;
        }
      }
      .attribute-add {
        .el-form-item__content {
          padding-bottom: 0;
        }
        .attribute-add-item {
          margin-left: 10px;
          padding-bottom: 10px;
        }
      }
      .value-item-form {
        border-bottom: 0;
      }
      .el-button {
        border-radius: 0;
      }
    }
    ::v-deep .el-radio {
      min-width: 100px;
    }
  }

  .prudoct-form {
    ::v-deep .el-form-item__content {
      width: calc(100% - 160px);
      margin-left: 0 !important;
      display: inline-block;
    }

    ::v-deep .el-form-item__label {
      font-size: 14px;
    }

    ::v-deep .el-form-item {
      margin-bottom: 20px;
      line-height: 1;
    }

    .no-edit {
      ::v-deep .el-form-item__label {
        line-height: 1;
      }

      ::v-deep .el-form-item__content {
        line-height: 1;
      }
    }
  }

  .title {
    width: 100%;
    line-height: 1;
    font-size: 16px;
    margin-bottom: 18px;
  }

  .sub-title {
    line-height: 40px;
    font-size: 14px;
    margin-bottom: 20px;
    background: #f5f5f5;
    padding-left: 20px;
  }

  .img-desc {
    padding: 0 0 6px 40px;
    font-size: 12px;
    line-height: 22px;
    margin-top: -10px;
    border-bottom: 1px solid #eee;
  }

  .upload-img {
    margin: 18px 118px;
  }

  .el-select {
    width: 100%;
  }

  .p-relative {
    position: relative;
    .icon {
      position: absolute;
      right: -30px;
      top: 5px;
      width: 22px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
  }

  .hideRemove ::v-deep .el-upload-list__item-delete {
    display: none !important;
  }

  .hideRemove ::v-deep .el-upload--picture-card {
    display: none !important;
  }

  .img-delail {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .submit-button {
    margin: 20px 0 30px 0;
    text-align: center;
  }
}
</style>
